import { render, staticRenderFns } from "./VTA.smartlinks.vue?vue&type=template&id=714ee48a&scoped=true&"
import script from "./VTA.smartlinks.vue?vue&type=script&lang=js&"
export * from "./VTA.smartlinks.vue?vue&type=script&lang=js&"
import style0 from "./VTA.smartlinks.vue?vue&type=style&index=0&id=714ee48a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ee48a",
  null
  
)

export default component.exports